import { handleRetrieveMemberAppointmentsDetails } from "../../../../../redux/specialist-slices/myMembers.slice"
import { Avatar, Box, Divider, Grid2 as Grid, ListItemText, Stack, Tab, Tabs, Typography } from "@mui/material"
import TabPanel from "../../../../../components/common/TabPanel"
import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Appointments from "./appointments"
import Documents from "./documents"

function Single() {
  const dispatch = useDispatch()
  const { id: memberId } = useParams()
  const [data, setData] = useState({})
  const [activeTab, setActiveTab] = useState("appointments")

  // --------------- Get all appointments ---------------
  const handleRetrieveAll = async (filters) => {

    const response = await dispatch(
      handleRetrieveMemberAppointmentsDetails({
        memberId,
        limit: 10,
        date: filters?.date || null,
        currentPage: filters?.currentPage || null,
      })
    ).unwrap() || {}
    if (response?.memberInfo)
      setData(response)
  }

  // --------------- Handle tab switch ---------------
  const handleTabChange = (_, value) => { setActiveTab(value) }

  useEffect(() => {
    handleRetrieveAll()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Grid container spacing={3}>
        <Grid size={12}>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            divider={<Divider flexItem sx={{ borderWidth: "thin" }} />}
          >
            <Avatar
              src={data?.memberInfo?.image || "/no-user.png"}
              sx={{ width: 50, height: 50 }}
            />
            <ListItemText
              primary={data?.memberInfo?.name || ""}
              slotProps={{
                secondary: {
                  style: { fontSize: 16, textTransform: "capitalize" },
                },
                primary: {
                  style: {
                    fontSize: 20,
                    fontWeight: "500",
                    textTransform: "capitalize",
                  },
                },
              }}
            />
            <ListItemText
              slotProps={{
                primary: {
                  style: { fontSize: 16, textTransform: "capitalize" },
                },
                secondary: {
                  style: { fontSize: 16, textTransform: "capitalize" },
                },
              }}
              secondary={
                <Typography>
                  <b>Blood Group : </b>
                  {data?.memberInfo?.bloodGroup || "N/A"}
                </Typography>
              }
              primary={
                <Box display="flex" gap={0.5}>
                  <Typography fontWeight={600}>Age :</Typography>
                  <Typography fontWeight={400}>
                    {data?.memberInfo?.age || "N/A"} {Boolean(data?.memberInfo?.age) && "Year(s)"}
                  </Typography>
                </Box>
              }
            />
          </Stack>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid size={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab value="appointments" label="Appointments" />
              <Tab value="documents" label="Documents" />
            </Tabs>
          </Box>
        </Grid>
      </Grid>

      <TabPanel value={activeTab} index="appointments">
        <Appointments data={data} handleRetrieveAll={handleRetrieveAll} />
      </TabPanel>

      <TabPanel value={activeTab} index="documents">
        <Documents memberId={memberId} />
      </TabPanel>
    </>
  )
}

export default Single